/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeSchematicLicenseChallengeDto,
  ApiEnvelopeSchematicLicenseVerifyResultDto,
  SchematicLicenseChallengeRequest,
  SchematicLicenseChallengeSubmitRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type schematicLicenseChallengeResponse200 = {
  data: ApiEnvelopeSchematicLicenseChallengeDto
  status: 200
}

export type schematicLicenseChallengeResponse400 = {
  data: ApiEnvelopeSchematicLicenseChallengeDto
  status: 400
}

export type schematicLicenseChallengeResponseSuccess = (schematicLicenseChallengeResponse200) & {
  headers: Headers;
};
export type schematicLicenseChallengeResponseError = (schematicLicenseChallengeResponse400) & {
  headers: Headers;
};

export type schematicLicenseChallengeResponse = (schematicLicenseChallengeResponseSuccess | schematicLicenseChallengeResponseError)

export const getSchematicLicenseChallengeUrl = () => {




  return `/api/schematic-license/challenge`
}

export const useSchematicLicenseChallengeHook = (): (schematicLicenseChallengeRequest?: SchematicLicenseChallengeRequest, options?: RequestInit) => Promise<schematicLicenseChallengeResponse> => {

      const customFetcher = useSfetchMutator();
      return (schematicLicenseChallengeRequest?: SchematicLicenseChallengeRequest, options?: RequestInit) => {

        return customFetcher(getSchematicLicenseChallengeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schematicLicenseChallengeRequest)
  }
);
      }
  }


export type schematicLicenseSubmitChallengeResponse200 = {
  data: ApiEnvelopeSchematicLicenseVerifyResultDto
  status: 200
}

export type schematicLicenseSubmitChallengeResponseSuccess = (schematicLicenseSubmitChallengeResponse200) & {
  headers: Headers;
};
;

export type schematicLicenseSubmitChallengeResponse = (schematicLicenseSubmitChallengeResponseSuccess)

export const getSchematicLicenseSubmitChallengeUrl = () => {




  return `/api/schematic-license/challenge/submit`
}

export const useSchematicLicenseSubmitChallengeHook = (): (schematicLicenseChallengeSubmitRequest?: SchematicLicenseChallengeSubmitRequest, options?: RequestInit) => Promise<schematicLicenseSubmitChallengeResponse> => {

      const customFetcher = useSfetchMutator();
      return (schematicLicenseChallengeSubmitRequest?: SchematicLicenseChallengeSubmitRequest, options?: RequestInit) => {

        return customFetcher(getSchematicLicenseSubmitChallengeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(schematicLicenseChallengeSubmitRequest)
  }
);
      }
  }


